import React, { useEffect, useState } from 'react'
import { connect, useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { fetchAllOpenComplaints, fetchComplaints } from '../../../../actions/complaint/complaintList'
import Complaints from '..'
import { AppState } from '../../../../reducers'
import { FilterTextField, Filters, FiltersBar } from '../../../Utils/Filters/Filter'
import { useTranslation } from 'react-i18next'
import { ComplaintListState } from '../../../../reducers/complaint/complaintList'
import { Button, Stack } from '@mui/material'
import Complaint from '../../../../models/Complaint'
import moment from 'moment'
import { FilterAssignedToComplaint, FilterFromDate, FilterInternalAssignedToComplaint, FilterNumber, FilterStatusComplaint, FilterToDate } from '../../../Utils/Filters'
import { fetchGeneralDesc } from '../../../../actions/generalDesc'
import { fetchComplaintTypes } from '../../../../actions/complaint/complaintTypesList'
import { SessionState, isAdmin, isClient, isHeadSales, isManager, isStaff } from '../../../../reducers/auth/session'
import { roleToURLPrefix } from '../../../../App'
import { PERSON } from '../../../../models/User'
import { upsertComplaint } from '../../../../actions/complaint/complaintUpsert'
import { GeneralDescState } from '../../../../reducers/generalDescList'

interface Props {
  fullInfo?: boolean
  complaintList: ComplaintListState
  generalDescList: GeneralDescState
  session: SessionState
}

const ComplaintList: React.FC<Props> = ({ complaintList, session, generalDescList, fullInfo = true}) => {
  const dispatch = useDispatch()
  const history = useHistory()
  const { t } = useTranslation('complaint')
  const [edit, setEdit] = useState(false)

  useEffect(() => {
    dispatch(fetchComplaintTypes())
    dispatch(fetchGeneralDesc('?type=cpt'))
  }, [dispatch])

  useEffect(() => {
    dispatch(fullInfo ? fetchComplaints(history.location.search) : fetchAllOpenComplaints())
  }, [dispatch, fullInfo, history.location.search, edit])

  const isVisible = ( ) => session.categoryId ? generalDescList.generalDesc?.find( gd => gd.id === session.categoryId )!.visible : true

  const initDefaultFilters: Filters = {
    dateOpenFrom: moment().startOf('year').subtract(1, 'years').tz("America/Argentina/Buenos_Aires").format(),
    dateOpenTo: moment().endOf('month').tz("America/Argentina/Buenos_Aires").format(),
    dateCloseFrom: '',
    dateCloseTo: moment().year(2099).endOf('year').tz("America/Argentina/Buenos_Aires").format(),
    status: 'U,R',
    assignedToId: !isClient(session) ? isStaff(session) ? !isVisible() ? '' : 'N,M' : isAdmin(session) || isManager(session) || isHeadSales(session) ? 'N,M,O' : 'N,M' : '',
    internalAssignedToId: isStaff(session) ? isVisible() ? '' : 'N,M' : '',
    ownerOpenId: isClient(session) ? 'M,O' : ''
  }


  const linkToComplaintTracking = (complaint: Complaint) => {
    const addUrl = isAdmin(session) ? `/admin/complaints/messages/${complaint.id}` : 
       isManager(session) ?  `/${session.roles && roleToURLPrefix(session.roles.filter(role => role !== PERSON)[0])}/complaints/messages/${complaint.id}&viewClientInfo=true` :
         `/${session.roles && roleToURLPrefix(session.roles.filter(role => role !== PERSON)[0])}/complaints/messages/${complaint.id}`
    history.push(addUrl, { title: t('complaintTracking') })
  }

  const linkToInternalComplaintTracking = (complaint: Complaint) => {
    const addUrl = isAdmin(session) ? `/admin/complaints/internal/messages/${complaint.id}` : 
     isManager(session) ? `/${session.roles && roleToURLPrefix(session.roles.filter(role => role !== PERSON)[0])}/complaints/internal/messages/${complaint.id}&viewClientInfo=true` :
     `/${session.roles && roleToURLPrefix(session.roles.filter(role => role !== PERSON)[0])}/complaints/internal/messages/${complaint.id}` 
    history.push(addUrl, { title: t('internalTracking') })
  }

  const changeDataComplaint = async (complaint: Complaint, status: boolean, assignedTo: boolean, internalAssignedTo: boolean) => {
    if (isAdmin(session) || isHeadSales(session) || isStaff(session)) {
      if (status) complaint.status = complaint.status === 'U' ? 'R' : 'U'
      if (assignedTo) 
        {
        if( !status )
          complaint.status = complaint.status === 'U' ? 'R' : complaint.status
        complaint.assignedToId = session.personId ? session.personId : complaint.assignedToId
        complaint.dateAssignedTo = moment().tz("America/Argentina/Buenos_Aires").format()
        }
      if (internalAssignedTo) 
       {
        complaint.internalAssignedToId = session.personId ? session.personId : complaint.internalAssignedToId
        complaint.internalDateAssignedTo = moment().tz("America/Argentina/Buenos_Aires").format()
       }
      setEdit(!edit)
    }
    try {
      await dispatch(upsertComplaint(complaint, () => dispatch(fullInfo ? fetchComplaints(history.location.search) : fetchAllOpenComplaints())))
    }
    catch {
    }
  }

  return (
    <Stack display="flex" flexDirection='column' justifyContent={isAdmin(session) || isManager(session) || isHeadSales(session) || isStaff(session) ? "normal" : "space-around"}>      
      {fullInfo && <FiltersBar defaultFilters={initDefaultFilters}>
        <FilterNumber style={{ width: "110px"}}  name="id" label={t("id")} />
        <FilterFromDate name="dateOpenFrom" label={t("dateOpenFrom")} />
        <FilterToDate name="dateOpenTo" label={t("dateOpenTo")} />
        {!isClient(session) ? <FilterFromDate name="dateCloseFrom" label={t("dateCloseFrom")} /> : <></>}
        {!isClient(session) ? <FilterToDate name="dateCloseTo" label={t("dateCloseTo")} /> : <></>}
        <FilterStatusComplaint name="status" label={t("status")} />
        {!isClient(session) && (!isStaff(session) || (isStaff(session) && isVisible())) ? <FilterAssignedToComplaint name="assignedToId" label={t("assignedToName")} /> : <></>}
        {isStaff(session) && !session.isChaco && !isVisible() ? <FilterInternalAssignedToComplaint name="internalAssignedToId" label={t("assignedToName")} /> : <></>}
        {(isStaff(session) || isHeadSales(session)) ? <FilterTextField name="byPersonTypeId" label={t("personType")} />: <></>}
        {/*
        !isClient(session) ? <FilterAssignedToComplaint name="assignedToId" label={t("assignedToName")} /> : <FilterOwnerOpenByComplaint name="ownerOpenId" label={t("ownerOpenName")} />
        */}
      </FiltersBar>}
      <Complaints
        rows={(complaintList.complaints || []).map(s => ({ data: s }))}
        loading={complaintList.isFetching}
        ownerId={session.personId || undefined}
        pagination={complaintList.pagination || undefined}
        onClickTracking={linkToComplaintTracking}
        onClickInternalTracking={linkToInternalComplaintTracking}
        onChangeData={changeDataComplaint}
        adminInfo={isAdmin(session) || isManager(session) || isHeadSales(session) || isStaff(session)}
        managerInfo={isManager(session)}
        staffInfo={isStaff(session)}
        isClient={isClient(session)}
        isChaco={session.isChaco || false}
        fullInfo={fullInfo}
      />
      {fullInfo && isClient(session) && 
      <Stack display="flex" flexDirection='row' justifyContent="space-between" padding="10px">
        <Button aria-label="back" size='large' style={{ textTransform: 'none', marginTop: '10px' }} onClick={() => history.push(`/${session.roles && roleToURLPrefix(session.roles.filter(role => role !== PERSON)[0])}/complaints/create`, { title: t('create') })}>
          {t('create')}
        </Button>
      </Stack>
      }
    </Stack >
  )
}

/*
      <Tooltip title={t("create")}>
      <Fab color="primary" size="medium" variant="extended" sx={{position: 'fixed', bottom: theme.spacing(4), right: theme.spacing(3)}} onClick={() => history.push(`/${session.roles && roleToURLPrefix(session.roles.filter(role => role !== PERSON)[0])}/complaints/create`, { title: t('create') })}>
        <Add />
      </Fab>
      </Tooltip>

*/

const mapStateToProps = (state: AppState) => ({
  session: state.session,
  complaintList: state.complaintList,
  generalDescList: state.generalDescList
})

export default connect(mapStateToProps, null)(ComplaintList)